export const INTEREST_SIGNAL_CODES = [
  'customerAwaitingReply',
  'noFirstResponse',
  'overdueTask',
  'engagementDetected',
  'missingNextStep',
  'goingCold',
] as const;
